// extracted by css-extract-rspack-plugin
export default {"before":"LevelBlank_before__Sf0Yq","space":"LevelBlank_space__AtvsM","arrow":"LevelBlank_arrow__EEv3D","nextline":"LevelBlank_nextline__l5wzQ","sizeM":"LevelBlank_sizeM__BMjgM"};